import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useSocketConnection, useUserProfileSocket } from '../../hooks/useSocket';
import { useForceLogout } from '../../hooks/useForceLogout';
import { useOrgStore } from '../../store/orgStore';
import ForceLogoutModal from '../admin/ForceLogoutModal';
import { ProfileModalProvider } from '../common/ProfileModalProvider';

export default function AppLayout() {
  // 앱 전체 소켓 연결 초기화
  useSocketConnection();
  // CHG-139 REQ-PF-005/006: 본인 프로필 변경 broadcast 수신 → 광범위 invalidate + store 동기화
  useUserProfileSocket();

  // CHG-060: 조직 목록 로드 + 온보딩 리다이렉트
  const navigate = useNavigate();
  const { fetchOrganizations } = useOrgStore();
  const [orgReady, setOrgReady] = useState(false);

  useEffect(() => {
    fetchOrganizations()
      .then((orgs) => {
        if (orgs.length === 0) {
          navigate('/onboarding', { replace: true });
        }
        setOrgReady(true);
      })
      .catch(() => {
        // 인증 에러(세션 만료) → 로그인 페이지로 이동 (온보딩 아님)
        navigate('/login', { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 권한 변경 / 계정 비활성화 시 강제 로그아웃
  const { showModal, message, handleConfirm } = useForceLogout();

  if (!orgReady) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }

  return (
    // CHG-131 REQ-CP-024: 어디서든 useProfileModal()로 프로필 모달을 열 수 있도록 최상단 Provider 마운트
    <ProfileModalProvider>
      <div className="h-screen flex flex-col overflow-hidden">
        <Header />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <main className="flex-1 overflow-y-auto bg-gray-50 p-6">
            <Outlet />
          </main>
        </div>
        {showModal && <ForceLogoutModal message={message} onConfirm={handleConfirm} />}
      </div>
    </ProfileModalProvider>
  );
}
